import RoboticAssestedJointReplacementContent from "./Expertise/RoboticAssistedJointReplacement/RoboticAssestedJointReplacementContent";
import RoboticAssistedJointReplacementIntroduction from "./Expertise/RoboticAssistedJointReplacement/RoboticAssistedJointReplacementIntroduction";

export default function RoboticAssistedJointReplacement() {
  return (
    <div>
      <RoboticAssistedJointReplacementIntroduction></RoboticAssistedJointReplacementIntroduction>
      <RoboticAssestedJointReplacementContent></RoboticAssestedJointReplacementContent>
    </div>
  );
}
